import React, { useState, useEffect, useRef } from "react";
import leftyTears from "../../assets/img/leftytears.png";
import logoLarge from "../../assets/img/logo-large.png";
import "./MainSection.css";
import { TitleBox } from "../Liquidity/Details/styled";

const MainSection = () => {
  const [isPopupVisible, setPopupVisible] = useState(false);
  const [hasSeenPopup, setHasSeenPopup] = useState(false);
  const mainDescriptionRef = useRef<HTMLParagraphElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (mainDescriptionRef.current && !hasSeenPopup) {
        const rect = mainDescriptionRef.current.getBoundingClientRect();
        const isVisible = rect.top <= window.innerHeight && rect.bottom >= 0;
        if (isVisible) {
          setPopupVisible(true);
          setHasSeenPopup(true); // Mark that the user has seen the popup
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [hasSeenPopup]);

  const closePopup = () => {
    setPopupVisible(false);
  };

  return (
    <section className="main-section" style={{ marginTop: "0px", marginBottom: "40px" }}>
      <img src={logoLarge} alt="Logo Large" className="logo-overlay" />
      <TitleBox style={{ marginTop: "0px", marginBottom: "20px" }}>
        <h1 className="text-center h1 glowing-header">
          Trade, Earn & Win crypto
          <br />
          <div className="flex flex-row">
            <span className="hodl-color glowing-header white-text-override not-glowing-header">
              on the world's fastest-growing DEX
            </span>
          </div>
        </h1>
      </TitleBox>
      <p ref={mainDescriptionRef} className="main-description">
        The Hodl Holdings Ecosystem is powered by <span className="token-name">$LeftyTears</span>,
        invest in the first batch to be released for a 50% discount and unlock exclusive early-bird
        investor rewards. Join the Presale Now!
        <br />
        <br />
        <span className="token-name">$LeftyTears</span> serves as the backbone of the Hodl Holdings
        Ecosystem, facilitating various functionalities within the platform such as trading,
        earning, and liquidity pools. This token encourages active participation within the
        community, fostering a sense of belonging and collective growth. By investing in the initial
        batch, early participants unlock exclusive rewards and incentives designed to maximize their
        benefits within the ecosystem.
      </p>
      <a className="presale-button" href="/presale">
        Join Presale
      </a>
      <div className="logos">
        <img src={leftyTears} alt="$LeftyTears" className="token-logo2" width="320px" />
        <p className="token-description">$LeftyTears</p>
      </div>

      {isPopupVisible && (
        <div className="popup">
          <button className="close-button" onClick={closePopup}>
            ×
          </button>
          <h2 className="popup-title">
            <span className="token-name">$LeftyTears</span> Presale
          </h2>
          <img src={leftyTears} alt="LeftyTears" className="popup-logo" />
          <p className="popup-text">
            The Hodl Holdings Ecosystem is powered by $LeftyTears, invest in the first tranche for a
            50% discount and unlock exclusive early-bird investor rewards.
          </p>
          <p className="popup-join-text">Join the Presale Now!</p>
          <a className="popup-button" href="/presale">
            Join Presale
          </a>
        </div>
      )}
    </section>
  );
};

export default MainSection;
